// extracted by mini-css-extract-plugin
module.exports = {"Main":"OffSiteOnHandItemHeader_Main__3GIiR","MenuItem":"OffSiteOnHandItemHeader_MenuItem__3Gk1_","SelectedMenuItem":"OffSiteOnHandItemHeader_SelectedMenuItem__1PG_g"};